import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center px-6 py-20 overflow-hidden bg-dark" data-id="element-62">
      {/* Background glow */}
      <div className="absolute inset-0 bg-radial-gold opacity-60 pointer-events-none" data-id="element-63"></div>

      <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12 relative z-10" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex-1 text-center lg:text-left" data-id="element-65">
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="inline-block mb-4 px-3 py-1 border border-gold/30 rounded-full text-gold text-xs font-sans tracking-widest uppercase" data-id="element-66">
            El Código de la Mujer de Élite
          </motion.div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-cream leading-tight mb-6" data-id="element-67">
            MAGNETISMO FEMENINO: <br data-id="element-68" />
            <span className="text-gold italic font-normal" data-id="element-69">
              Las Cualidades de la Mujer de Élite
            </span>
          </h1>

          <p className="font-sans text-lg md:text-xl text-cream/80 font-light leading-relaxed mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-70">
            Deja de ser invisible para el hombre que deseas y conviértete en la
            presencia más magnética de la habitación sin decir una sola palabra.
          </p>

          <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-71">
            <CTAButton data-id="element-72" />
            <p className="text-xs text-cream/50 font-sans tracking-wide" data-id="element-73">
              Acceso instantáneo • Pago seguro
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 1,
        ease: 'easeOut'
      }} className="flex-1 w-full max-w-md relative" data-id="element-74">
          <div className="absolute -inset-4 bg-gold/20 blur-3xl rounded-full" data-id="element-75"></div>
          <img src="https://cdn.magicpatterns.com/uploads/2VEPEM7bP6opERRQagfvkU/Magnetismo_FemeninoPortada.jpg" alt="Magnetismo Femenino Book Cover" className="w-full h-auto rounded-md shadow-2xl shadow-gold/10 relative z-10 border border-gold/20" data-id="element-76" />
        </motion.div>
      </div>
    </section>;
}